/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * ScaleFi Nub APIs
 * Scale Fi Apis
 * OpenAPI spec version: v0.0.1
 */
import {
  useInfiniteQuery,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetAppearanceConfig200
} from '../model';

import { customInstance } from '../mutator/custom-instance';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getAppearanceConfig = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetAppearanceConfig200>(
      {url: `/public/appearance`, method: 'GET', signal
    },
      options);
    }
  



export const getGetAppearanceConfigInfiniteQueryKey = () => {
    return [
    'infinite', `/public/appearance`
    ] as const;
    }

export const getGetAppearanceConfigQueryKey = () => {
    return [
    `/public/appearance`
    ] as const;
    }

    
export const getGetAppearanceConfigInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getAppearanceConfig>>>, TError = unknown>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAppearanceConfig>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAppearanceConfigInfiniteQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAppearanceConfig>>> = ({ signal }) => getAppearanceConfig(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAppearanceConfig>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAppearanceConfigInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getAppearanceConfig>>>
export type GetAppearanceConfigInfiniteQueryError = unknown


export function useGetAppearanceConfigInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAppearanceConfig>>>, TError = unknown>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAppearanceConfig>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAppearanceConfig>>,
          TError,
          Awaited<ReturnType<typeof getAppearanceConfig>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAppearanceConfigInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAppearanceConfig>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAppearanceConfig>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAppearanceConfig>>,
          TError,
          Awaited<ReturnType<typeof getAppearanceConfig>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAppearanceConfigInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAppearanceConfig>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAppearanceConfig>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAppearanceConfigInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAppearanceConfig>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAppearanceConfig>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAppearanceConfigInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetAppearanceConfigQueryOptions = <TData = Awaited<ReturnType<typeof getAppearanceConfig>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppearanceConfig>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAppearanceConfigQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAppearanceConfig>>> = ({ signal }) => getAppearanceConfig(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAppearanceConfig>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAppearanceConfigQueryResult = NonNullable<Awaited<ReturnType<typeof getAppearanceConfig>>>
export type GetAppearanceConfigQueryError = unknown


export function useGetAppearanceConfig<TData = Awaited<ReturnType<typeof getAppearanceConfig>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppearanceConfig>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAppearanceConfig>>,
          TError,
          Awaited<ReturnType<typeof getAppearanceConfig>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAppearanceConfig<TData = Awaited<ReturnType<typeof getAppearanceConfig>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppearanceConfig>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAppearanceConfig>>,
          TError,
          Awaited<ReturnType<typeof getAppearanceConfig>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAppearanceConfig<TData = Awaited<ReturnType<typeof getAppearanceConfig>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppearanceConfig>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAppearanceConfig<TData = Awaited<ReturnType<typeof getAppearanceConfig>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppearanceConfig>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAppearanceConfigQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getLogo = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<string>(
      {url: `/public/appearance/logo`, method: 'GET', signal
    },
      options);
    }
  



export const getGetLogoInfiniteQueryKey = () => {
    return [
    'infinite', `/public/appearance/logo`
    ] as const;
    }

export const getGetLogoQueryKey = () => {
    return [
    `/public/appearance/logo`
    ] as const;
    }

    
export const getGetLogoInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getLogo>>>, TError = unknown>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLogo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLogoInfiniteQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLogo>>> = ({ signal }) => getLogo(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLogo>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetLogoInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getLogo>>>
export type GetLogoInfiniteQueryError = unknown


export function useGetLogoInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLogo>>>, TError = unknown>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLogo>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLogo>>,
          TError,
          Awaited<ReturnType<typeof getLogo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLogoInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLogo>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLogo>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLogo>>,
          TError,
          Awaited<ReturnType<typeof getLogo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLogoInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLogo>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLogo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetLogoInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLogo>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLogo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetLogoInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetLogoQueryOptions = <TData = Awaited<ReturnType<typeof getLogo>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLogo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLogoQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLogo>>> = ({ signal }) => getLogo(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLogo>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetLogoQueryResult = NonNullable<Awaited<ReturnType<typeof getLogo>>>
export type GetLogoQueryError = unknown


export function useGetLogo<TData = Awaited<ReturnType<typeof getLogo>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLogo>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLogo>>,
          TError,
          Awaited<ReturnType<typeof getLogo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLogo<TData = Awaited<ReturnType<typeof getLogo>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLogo>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLogo>>,
          TError,
          Awaited<ReturnType<typeof getLogo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLogo<TData = Awaited<ReturnType<typeof getLogo>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLogo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetLogo<TData = Awaited<ReturnType<typeof getLogo>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLogo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetLogoQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getLoginLogo = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<string>(
      {url: `/public/appearance/login-logo`, method: 'GET', signal
    },
      options);
    }
  



export const getGetLoginLogoInfiniteQueryKey = () => {
    return [
    'infinite', `/public/appearance/login-logo`
    ] as const;
    }

export const getGetLoginLogoQueryKey = () => {
    return [
    `/public/appearance/login-logo`
    ] as const;
    }

    
export const getGetLoginLogoInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getLoginLogo>>>, TError = unknown>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoginLogo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLoginLogoInfiniteQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLoginLogo>>> = ({ signal }) => getLoginLogo(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoginLogo>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetLoginLogoInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getLoginLogo>>>
export type GetLoginLogoInfiniteQueryError = unknown


export function useGetLoginLogoInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLoginLogo>>>, TError = unknown>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoginLogo>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoginLogo>>,
          TError,
          Awaited<ReturnType<typeof getLoginLogo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLoginLogoInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLoginLogo>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoginLogo>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoginLogo>>,
          TError,
          Awaited<ReturnType<typeof getLoginLogo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLoginLogoInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLoginLogo>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoginLogo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetLoginLogoInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLoginLogo>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoginLogo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetLoginLogoInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetLoginLogoQueryOptions = <TData = Awaited<ReturnType<typeof getLoginLogo>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoginLogo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLoginLogoQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLoginLogo>>> = ({ signal }) => getLoginLogo(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLoginLogo>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetLoginLogoQueryResult = NonNullable<Awaited<ReturnType<typeof getLoginLogo>>>
export type GetLoginLogoQueryError = unknown


export function useGetLoginLogo<TData = Awaited<ReturnType<typeof getLoginLogo>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoginLogo>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoginLogo>>,
          TError,
          Awaited<ReturnType<typeof getLoginLogo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLoginLogo<TData = Awaited<ReturnType<typeof getLoginLogo>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoginLogo>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoginLogo>>,
          TError,
          Awaited<ReturnType<typeof getLoginLogo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLoginLogo<TData = Awaited<ReturnType<typeof getLoginLogo>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoginLogo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetLoginLogo<TData = Awaited<ReturnType<typeof getLoginLogo>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoginLogo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetLoginLogoQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




